import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import SmartScanningProxyOnboarding from './SmartScanningProxyOnboarding';
import './SmartScanningProxy.scss';

function TabPanel(props: {
  children?: React.ReactNode;
  value: number;
  index: number;
  [key: string]: unknown;
}) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

export default function SmartScanningProxy() {
  const [value, setValue] = React.useState(0);

  return (
    <div className="ssp-container" id="twindolphin-onboarding-container">
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Tabs
          value={value}
          onChange={(e, v) => setValue(v)}
          TabIndicatorProps={{ style: { backgroundColor: 'var(--color-primary)' } }}
          id="twindolphin-onboarding-tabs"
          aria-label="SMSC onboarding navigation"
          sx={{ minHeight: 36 }}
        >
          <Tab
            icon={<PersonAddOutlinedIcon fontSize="small" />}
            iconPosition="start"
            label="Client Configuration"
            className={value === 0 ? 'ssp-tab-selected' : 'ssp-tab-unselected'}
            sx={{ minHeight: 36, py: 0.25, px: 1.5, fontSize: 13 }}
            id="twindolphin-onboarding-tab"
            aria-controls="twindolphin-onboarding-panel"
          />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0} id="twindolphin-onboarding-panel">
        <SmartScanningProxyOnboarding />
      </TabPanel>
    </div>
  );
}
